import { RuntimeConfig } from "./runtime";

export interface IEnvVars {
    API_SERVER: string;
    API_VERSION: string;
}

export const env: IEnvVars = {
    API_SERVER: RuntimeConfig.API_SERVER,
    API_VERSION: RuntimeConfig.API_VERSION,
};
